module.exports = __webpack_public_path__ + "img/withdrawItem.ad561153.png";